<template>
  <div
    class="font-inter overflow-hidden bg-gray-50 dark:bg-background"
  >
    <LearningGoalDetailsComponent />
  </div>
</template>

<script>
import LearningGoalDetailsComponent from "@/components/learning-goals/LearningGoalDetailsComponent.vue";

export default {
  name: "LearningGoalDetails",
  components: {
    LearningGoalDetailsComponent,
  },
  methods: {},
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped></style>
